import reducer from './reducers'

export { default as studentActions } from './actions'
export { default as studentOperations } from './operations'

export default reducer